import React, { useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';
import { TextField, Button, CircularProgress } from '@mui/material';
import { getAuthenticatedUser, withAuthRefresh } from '../../../utils/auth';

export default function MyNote({ questionId }) {
  const [note, setNote] = useState('');
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchNote = async () => {
      // questionId가 변경될 때마다 상태 초기화
      setNote('');
      setLoading(true);
      
      try {
        await withAuthRefresh(async (user) => {
          const { data, error } = await supabase
            .from('mbe_user_notes')
            .select('note')
            .eq('user_id', user.id)
            .eq('question_id', questionId)
            .maybeSingle(); // single() 대신 maybeSingle() 사용
          
          if (error) {
            console.error('노트 조회 오류:', error);
          } else if (data) {
            setNote(data.note || '');
          }
        });
      } catch (error) {
        console.error('노트 조회 중 예외 발생:', error);
        if (error.message?.includes('인증이 필요합니다')) {
          // 인증 실패 시 사용자에게 알림
          alert('로그인이 만료되었습니다. 페이지를 새로고침해주세요.');
        }
      } finally {
        setLoading(false);
      }
    };
    
    if (questionId) {
      fetchNote();
    }
  }, [questionId]);

  const handleSave = async () => {
    try {
      await withAuthRefresh(async (user) => {
        const { error } = await supabase.from('mbe_user_notes').upsert({
          user_id: user.id,
          question_id: questionId,
          note,
        });
        
        if (error) {
          console.error('노트 저장 오류:', error);
          alert('노트 저장에 실패했습니다.');
        } else {
          setSaved(true);
          setTimeout(() => setSaved(false), 1500);
        }
      });
    } catch (error) {
      console.error('노트 저장 중 예외 발생:', error);
      if (error.message?.includes('인증이 필요합니다')) {
        alert('로그인이 만료되었습니다. 페이지를 새로고침해주세요.');
      } else {
        alert('노트 저장에 실패했습니다.');
      }
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <CircularProgress size={16} />
        <span>노트 불러오는 중...</span>
      </div>
    );
  }

  return (
    <div>
      <TextField
        label="나만의 해설/노트"
        value={note}
        onChange={e => setNote(e.target.value)}
        multiline
        minRows={2}
        fullWidth
        placeholder="이 문제에 대한 나만의 해설이나 노트를 작성해보세요..."
      />
      <Button onClick={handleSave} size="small" sx={{ mt: 1 }}>
        저장
      </Button>
      {saved && <span style={{ color: 'green', marginLeft: 8 }}>저장됨</span>}
    </div>
  );
}
